import {FC, ComponentPropsWithoutRef} from 'react'
import classNames from 'classnames'
import {Close} from 'jbc-front/components/icons'
import styles from 'jbc-front/components/SearchForm.scss'

export const Details: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.details, className)} {...rest}>
    {children}
  </div>
)

export const Row: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsRow, className)} {...rest}>
    {children}
  </div>
)

export const Header: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsHeader, className)} {...rest}>
    {children}
  </div>
)

export const Body: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsBody, className)} {...rest}>
    {children}
  </div>
)

export const BodyItems: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsBodyItems, className)} {...rest}>
    {children}
  </div>
)

export const BodyErrors: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsBodyErrors, className)} {...rest}>
    {children}
  </div>
)

export const BodyNotes: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.notes, className)} {...rest}>
    {children}
  </div>
)

export const ComplementText: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.detailsComplementText, className)} {...rest}>
    {children}
  </div>
)

interface AddedFieldProps extends ComponentPropsWithoutRef<'div'> {
  onRemove?: () => void
}

export const AddedField: FC<AddedFieldProps> = ({className, children, onRemove, ...rest}) => (
  <div className={classNames(styles.addedField, className)} {...rest}>
    {children}
    <a className={styles.close} onClick={onRemove}>
      <Close />
    </a>
  </div>
)

export const AddFieldSelect: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...rest}) => (
  <div className={classNames(styles.addFieldSelect, className)} {...rest}>
    {children}
  </div>
)
